import { render } from "./EditReview.vue?vue&type=template&id=6f1a5407&scoped=true"
import script from "./EditReview.vue?vue&type=script&lang=js"
export * from "./EditReview.vue?vue&type=script&lang=js"

import "./EditReview.vue?vue&type=style&index=0&id=6f1a5407&lang=scss&scoped=true"
import "./review.scss?vue&type=style&index=1&id=6f1a5407&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f1a5407"]])

export default __exports__